@if (!tooltipOnly) {
  <span class="item-label" [class.hidden-by-quick-filter]="hiddenByQuickFilter" [class.dev-highlight]="devHighlight" [class.gem-color]="gem" [class.icon-only]="iconOnly" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
    @if (image) {
      @if (unique || gear || jewellery || gameItem) {
        <img class="base-type-image" [src]="imgPrefix + image" loading="lazy" />
      } @else {
        <img class="base-type-image" [src]="imgPrefix + image" width="18" height="18" loading="lazy" />
      }
    }
    @if (!iconOnly) {
      <span>
        {{ displayLabel || baseType }}
      </span>
      @if (sockets) {
        <app-sockets-display [sockets]="sockets"></app-sockets-display>
      }
      @if (unique && droppedByBoss) {
        @if (droppedByContentIcon) {
          <img class="restricted-icon" [src]="imgPrefix + droppedByContentIcon" title="Dropped by {{ droppedByBoss }}" width="16" height="16" loading="lazy" />
        } @else {
          <span class="restricted-icon icon icon-lock" title="Dropped by {{ droppedByBoss }}"></span>
        }
      } @else if (restricted) {
        <span class="restricted-icon" title="Dropped by {{ restricted }}">
          @if (restrictedContentIcon) {
            <img [src]="imgPrefix + restrictedContentIcon" width="16" height="16" />
          } @else {
            <span class="icon icon-lock"></span>
          }
        </span>
      }
    }
  </span>
}

@if (tooltipOnly || (!hideTooltip && showTooltip)) {
  @if (itemType === 'UnidentifiedUnique') {
    <div class="item-tooltip item-border" [class.relative]="tooltipOnly">
      <div class="it-name">
        <h3 class="unique-item-color">{{ baseType }}</h3>
      </div>
      <div class="it-body">
        @for (entry of unidentifiedUniqueEntries; track entry.name) {
          <div class="it-section it-effects it-unidentified-unique-section">
            <div class="it-unique-header">
              @if (entry.image) {
                <img class="it-unique-image" [src]="imgPrefix + entry.image" />
              }
              <div class="it-unique-title">
                <div class="it-unique-name-title" [class.has-boss-icon]="entry.bossDrop">
                  <h3 class="unique-item-color">
                    <span class="it-unique-name-label">{{ entry.name }}</span>
                    @if (entry.bossDrop) {
                      @if (entry.bossDropContentIcon) {
                        <img class="it-unique-boss-icon restricted-icon" [src]="imgPrefix + entry.bossDropContentIcon" title="Dropped by {{ entry.bossDrop }}" />
                      } @else {
                        <span class="it-unique-boss-icon restricted-icon icon icon-lock" title="Dropped by {{ entry.bossDrop }}"></span>
                      }
                    }
                  </h3>
                </div>
                @if (!filterStoreService.activeFilter().ssf) {
                  <div class="it-value">
                    <span app-value [baseType]="entry.name" [unique]="true"
                      [showPreviousValue]="showPreviousValue" [manualTier]="manualTier"></span>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
      <ng-container *ngTemplateOutlet="libraryFooter"></ng-container>
    </div>
  } @else if (gearData || jewelleryData) {
    <div class="item-tooltip" [class.relative]="tooltipOnly">
      <div class="it-gear-container">
        <img class="it-gear-image" [src]="imgPrefix + image" />
        <div class="it-gear-content item-border">
          <div class="it-name">
            <h3 [class.normal-item-color]="!rarity"
              [class.magic-item-color]="rarity === 'Magic'"
              [class.rare-item-color]="rarity === 'Rare'"
              [class.unique-item-color]="rarity === 'Unique'">
              @if (gameItem?.rarity === 'Rare' && gameItem?.identified !== false) {
                {{ gameItem?.name }}<br />
              }
              @if (tierNavigationEnabled) {
                <span class="gear-tier-nav-link"
                  [class.hovered]="baseTypeNavHovered()"
                  (mouseenter)="onBaseTypeMouseEnter()"
                  (mouseleave)="onBaseTypeMouseLeave()"
                  (click)="onBaseTypeClick($event)">{{ baseType }}</span>
              } @else {
                {{ baseType }}
              }
            </h3>
          </div>
          <div class="it-body">
            <ng-container *ngTemplateOutlet="restrictedBanner"></ng-container>

            @if (ilvlValues.length > 0 && !filterStoreService.activeFilter().ssf) {
              <div class="it-section it-value">
                <span class="it-property-name">iLvl </span>
                @for (entry of ilvlValues; track entry.ilvl; let last = $last) {
                  <span class="it-effect it-property-name">
                    <span class="property-value-color">{{ entry.ilvl }}</span>:
                    <span app-value [value]="entry.pricedItem" [subtle]="true"></span>
                  </span>
                  @if (!last) {
                    <span class="it-property-name"> / </span>
                  }
                }
              </div>
            }

            @if (usageDisplay && !filterStoreService.activeFilter().ssf) {
              <div class="it-section it-value">
                <span class="it-property-name">Usage: <span class="property-value-color">{{ usageDisplay }}</span></span>
              </div>
            }

            @if (gearData && (gearData.minDmg || gearData.maxDmg || gearData.aps || gearData.crit)) {
              <div class="it-section it-effects">
                @if (gearData.minDmg && gearData.maxDmg) { <div class="it-effect it-property-name">Damage: <span class="property-value-color">{{ gearData.minDmg }}-{{ gearData.maxDmg }}</span></div> }
                @if (gearData.aps) { <div class="it-effect it-property-name">Attacks per Second: <span class="property-value-color">{{ gearData.aps }}</span></div> }
                @if (gearData.rt) { <div class="it-effect it-property-name">Reload Time: <span class="property-value-color">{{ gearData.rt }}</span></div> }
                @if (gearData.crit) { <div class="it-effect it-property-name">Critical Strike Chance: <span class="property-value-color">{{ gearData.crit }}%</span></div> }
                @if (weaponDps) { <div class="it-effect it-property-name">DPS: <span class="property-value-color">{{ weaponDps }}</span></div> }
              </div>
            }

            @if (gearData && (gearData.block || gearData.arm || gearData.ev || gearData.es)) {
              <div class="it-section it-effects">
                @if (gearData.block) { <div class="it-effect it-property-name">Block: <span class="property-value-color">{{ gearData.block }}%</span></div> }
                @if (gearData.arm) { <div class="it-effect it-property-name">Armour: <span class="property-value-color">{{ gearData.arm }}</span></div> }
                @if (gearData.ev) { <div class="it-effect it-property-name">Evasion: <span class="property-value-color">{{ gearData.ev }}</span></div> }
                @if (gearData.es) { <div class="it-effect it-property-name">Energy Shield: <span class="property-value-color">{{ gearData.es }}</span></div> }
              </div>
            }

            @if (gameItem?.requirements?.level || gameItem?.requirements?.str || gameItem?.requirements?.dex || gameItem?.requirements?.int
              || equippableStaticData?.lvl || equippableStaticData?.str || equippableStaticData?.dex || equippableStaticData?.int
              || gearData?.dropLvl || gearData?.job) {
              <div class="it-section it-effects">
                @if (gameItem?.requirements?.level || gameItem?.requirements?.str || gameItem?.requirements?.dex || gameItem?.requirements?.int) {
                  <div class="it-property-name requirements">
                    Requires
                    @if (gameItem?.requirements?.level) {
                      <span class="it-effect">Level <span class="property-value-color">{{ gameItem?.requirements?.level }}</span></span>
                    }
                    @if (gameItem?.requirements?.str || gameItem?.requirements?.dex || gameItem?.requirements?.int) {
                      @if (gameItem?.requirements?.str) { <span class="it-effect"><span class="property-value-color">{{ gameItem?.requirements?.str }}</span> Str</span> }
                      @if (gameItem?.requirements?.dex) { <span class="it-effect"><span class="property-value-color">{{ gameItem?.requirements?.dex }}</span> Dex</span> }
                      @if (gameItem?.requirements?.int) { <span class="it-effect"><span class="property-value-color">{{ gameItem?.requirements?.int }}</span> Int</span> }
                    }
                  </div>
                } @else if (equippableStaticData?.lvl || equippableStaticData?.str || equippableStaticData?.dex || equippableStaticData?.int) {
                  <div class="it-property-name requirements">
                    Requires
                    @if (equippableStaticData?.lvl) {
                      <span class="it-effect">Level <span class="property-value-color">{{ equippableStaticData?.lvl }}</span></span>
                    }
                    @if (equippableStaticData?.str) { <span class="it-effect"><span class="property-value-color">{{ equippableStaticData?.str }}</span> Str</span> }
                    @if (equippableStaticData?.dex) { <span class="it-effect"><span class="property-value-color">{{ equippableStaticData?.dex }}</span> Dex</span> }
                    @if (equippableStaticData?.int) { <span class="it-effect"><span class="property-value-color">{{ equippableStaticData?.int }}</span> Int</span> }
                  </div>
                }
                @if (gearData?.job) {
                  <div class="it-property-name">
                    Requires Job: <span class="property-value-color">{{ gearData!.job }}</span>
                  </div>
                }
                @if (gearData?.dropLvl) {
                  <div class="it-property-name">
                    Drop Level: <span class="property-value-color">{{ gearData!.dropLvl }}</span>
                  </div>
                }
              </div>
            }

            <ng-container *ngTemplateOutlet="gameItemModSections; context: { useStaticImplicits: true, showAugmentMods: true }"></ng-container>

            <ng-container *ngTemplateOutlet="rewardedBySection"></ng-container>
            <ng-container *ngTemplateOutlet="explainerFooter"></ng-container>

            @if (tierNavigationEnabled && tierNavigationHint) {
              <div class="it-section it-description property-color">
                <span class="keys"><span class="key">Ctrl</span></span>-Click base type to open {{ tierNavigationHint }}
              </div>
            }
          </div>
          <ng-container *ngTemplateOutlet="libraryFooter"></ng-container>
        </div>
      </div>
    </div>
  } @else if (unique) {
    <div class="item-tooltip item-border" [class.relative]="tooltipOnly">
      <div class="it-name">
        <div class="it-unique-header">
          @if (image) {
            <img class="it-unique-image" [src]="imgPrefix + image" />
          }
          <div class="it-unique-title">
            <h3 class="unique-item-color">
              {{ name }}
            </h3>
            <div class="it-subtitle unique-item-color">{{ itemBaseType }}</div>
          </div>
        </div>
      </div>
      <div class="it-body">
        <ng-container *ngTemplateOutlet="droppedByBanner"></ng-container>
        @if (!filterStoreService.activeFilter().ssf || dustValue || uniqueTier != null) {
          <div class="it-section it-value">
            @if (!filterStoreService.activeFilter().ssf) {
              <span app-value [baseType]="baseType" [unique]="true" [showPreviousValue]="showPreviousValue" [manualTier]="manualTier"></span>
            }
            @if (dustValue) {
              <span class="property-value-color" [style.margin-left.px]="filterStoreService.activeFilter().ssf ? 0 : 8">
                <img class="inline-image" [src]="imgPrefix + '/img/icons/dust.png'" /> {{ displayDustValue }}
              </span>
            }
            @if (uniqueTier != null) {
              <span [style.margin-left.px]="!filterStoreService.activeFilter().ssf || dustValue ? 8 : 0">
                <span class="property-color">T</span><span class="property-value-color unique-tier-number">{{ uniqueTier }}</span>
              </span>
            }
          </div>
          @if (!filterStoreService.activeFilter().ssf) {
            <div class="it-section it-effects">
              <app-value-history [name]="baseType" [unique]="true"></app-value-history>
            </div>
          }
        }
        <ng-container *ngTemplateOutlet="modList; context: { mods: implicitMods }"></ng-container>
        <ng-container *ngTemplateOutlet="modList; context: { mods: explicitMods }"></ng-container>
        @if (flavorText) {
          <div class="it-section it-flavor-text unique-item-color it-description">
            {{ flavorText }}
          </div>
        }
        <ng-container *ngTemplateOutlet="rewardedBySection"></ng-container>
        <ng-container *ngTemplateOutlet="explainerFooter"></ng-container>
      </div>
      <ng-container *ngTemplateOutlet="libraryFooter"></ng-container>
    </div>
  } @else if (gem || !gameItem || gameItem.rarity === 'Currency' || gemDescription) {
    <div class="item-tooltip item-border" [class.relative]="tooltipOnly">
      <div class="it-name it-name-currency">
        <h3 [class.gem-color]="gem">
          @if (image) {
            <img class="base-type-image" [src]="imgPrefix + image" width="18" height="18" />
          }
          {{ baseType }}
        </h3>
      </div>
      <div class="it-body">
        @if (!gem && !filterStoreService.activeFilter().ssf) {
          <div class="it-section it-value" app-value [baseType]="baseType" [showPreviousValue]="showPreviousValue" [manualTier]="manualTier" [favouriteCurrencyAdjusted]="favouriteCurrencyAdjusted"></div>
          <div class="it-section it-effects">
            <app-value-history [name]="baseType" [unique]="false"></app-value-history>
          </div>
        }
        @if (gemDescription) {
          <div class="it-section it-effects it-gem-description">
            {{ gemDescription }}
          </div>
        }
        <ng-container *ngTemplateOutlet="effectsList"></ng-container>
        @if (description && !gameItem) {
          <div class="it-section it-description" [class.gem-color]="gem" [class.property-color]="!gem">
            {{ description }}
          </div>
        }
        <ng-container *ngTemplateOutlet="rewardedBySection"></ng-container>
      </div>
      <ng-container *ngTemplateOutlet="libraryFooter"></ng-container>
    </div>
  } @else if (gameItem) {
    <div class="item-tooltip item-border" [class.relative]="tooltipOnly">
      <div class="it-name">
        <h3 class="game-item-title"
          [class.normal-item-color]="rarity === 'Normal'"
          [class.magic-item-color]="rarity === 'Magic'"
          [class.rare-item-color]="rarity === 'Rare'"
          [class.unique-item-color]="rarity === 'Unique'">
          @if (image) {
            <img class="base-type-image" [src]="imgPrefix + image" />
          }
          <span>
            @if (gameItem.rarity === 'Rare' && gameItem.name) {
              {{ gameItem.name }}<br />
              {{ baseType }}
            } @else if (gameItem.rarity === 'Magic') {
              {{ gameItem.name }}
            } @else {
              {{ baseType }}
            }
          </span>
        </h3>
      </div>
      <div class="it-body">
        <ng-container *ngTemplateOutlet="gameItemModSections; context: { useStaticImplicits: false, showAugmentMods: false }"></ng-container>
      </div>
      <ng-container *ngTemplateOutlet="libraryFooter"></ng-container>
    </div>
  }
}

<ng-template #restrictedBanner>
  @if (restricted) {
    <div class="it-name property-value-color">
      <span class="restricted-icon icon icon-lock"></span>
      Dropped by {{ restricted }}
      @if (restrictedContentIcon) {
        <img class="inline-image restricted-icon" [src]="imgPrefix + restrictedContentIcon" />
      }
    </div>
  }
</ng-template>

<ng-template #droppedByBanner>
  @if (droppedByBoss) {
    <div class="it-name">
      <span class="icon icon-lock restricted-icon"></span>
      Dropped by {{ droppedByBoss }}
      @if (droppedByContentIcon) {
        <img class="inline-image restricted-icon" [src]="imgPrefix + droppedByContentIcon" />
      }
    </div>
  }
</ng-template>

<ng-template #rewardedBySection>
  @if (rewardedByCards.length > 0) {
    <div class="it-section rewarded-by">
      <div class="it-property-name">
        <img class="rewarded-by-icon" [src]="imgPrefix + '/img/gear/divination/divinationcard.webp'" width="16" height="16" />
        Rewarded by:
      </div>
      @for (card of rewardedByCards; track card.name) {
        <div class="rewarded-by-card it-property-name">
          {{ card.stackSize }}x <span class="divination-card-color">{{ card.name }}</span>
          @if (card.flagsLabel) {
            ({{ card.flagsLabel }})
          }
          @if (!filterStoreService.activeFilter().ssf) {
            <span class="rewarded-by-value" app-value [baseType]="card.name" [rtl]="true" [subtle]="true" [hideExtraInfo]="true"></span>
          }
        </div>
      }
    </div>
  }
</ng-template>

<ng-template #modList let-mods="mods">
  @if (mods && mods.length > 0) {
    <div class="it-section it-effects">
      @for (mod of mods; track $index) {
        <div class="it-effect description" [innerHTML]="mod"></div>
      }
    </div>
  }
</ng-template>

<ng-template #effectsList>
  @if (effects && effects.length > 0) {
    <div class="it-section it-effects">
      @for (effect of effects; track $index) {
        <div class="it-effect description" [innerHTML]="effect"></div>
      }
    </div>
  }
</ng-template>

<ng-template #gameItemModSections let-useStaticImplicits="useStaticImplicits" let-showAugmentMods="showAugmentMods">
  @if (showAugmentMods && gameItem?.augmentMods && gameItem!.augmentMods!.length > 0) {
    <div class="it-section it-effects">
      @for (augmentMod of gameItem!.augmentMods!; track $index) {
        <div class="it-effect description augment-color" [innerHTML]="augmentMod"></div>
      }
    </div>
  }

  @if (gameItem?.implicitMods && gameItem!.implicitMods!.length > 0) {
    <div class="it-section it-effects">
      @for (implicitMod of gameItem!.implicitMods!; track $index) {
        <div class="it-effect description" [innerHTML]="implicitMod"></div>
      }
    </div>
  } @else if (useStaticImplicits && implicitMods && implicitMods.length > 0) {
    <div class="it-section it-effects">
      @for (implicitMod of implicitMods; track $index) {
        <div class="it-effect description" [innerHTML]="implicitMod"></div>
      }
    </div>
  }

  @if (gameItem?.hasEnchantment) {
    <div class="it-section it-effects">
      <div class="it-effect description enchantment-color" [innerHTML]="gameItem?.hasEnchantment"></div>
    </div>
  }

  @if (gameItem && gameItem.identified === false) {
    <div class="it-section it-effects">
      <div class="it-effect unidentified-color">Unidentified @if (gameItem.unidentifiedItemTier) { (Tier {{ gameItem.unidentifiedItemTier }}) }</div>
    </div>
  }

  @if (gameItem?.explicitMods && gameItem!.explicitMods!.length > 0) {
    <div class="it-section it-effects">
      @for (explicitMod of gameItem!.explicitMods!; track $index) {
        <div class="it-effect description" [innerHTML]="explicitMod"></div>
      }
    </div>
  }

  @if (gameItem && gameItem.corrupted === true) {
    <div class="it-section it-effects">
      <div class="it-effect corrupted-color">Corrupted</div>
    </div>
  }
</ng-template>

<ng-template #libraryFooter>
  @if ((showItemLibraryRemoveHint || showRandomLootAddHint || showSimulatorRuleInfo) && simulatorResult; as sim) {
    <div class="it-footer">
      <div class="it-footer-header property-value-color">
        {{ sim.shown ? 'Shown' : 'Hidden' }}
        @if (sim.rule?.name; as ruleName) {
          by @if (!sim.noMatch) { {{ sim.shown ? 'Show' : 'Hide' }} } {{ ruleName }}
        }
      </div>
      <div class="it-footer-body">
        @if (sim.styledByPartialRules && sim.styledByPartialRules.length > 0) {
          <div class="it-section it-effects it-footer-partial-rules">
            <div class="it-property-name">Styled by partial rules:</div>
            @for (partialRule of sim.styledByPartialRules; track $index) {
              <div class="it-effect property-value-color">{{ partialRule.ruleDescription.name || 'Unnamed' }}</div>
            }
          </div>
        }
        @if (showItemLibraryRemoveHint || showRandomLootAddHint || (showSimulatorRuleInfo && sim.rule?.completeId)) {
          <div class="it-section it-description property-color">
            @if (showItemLibraryRemoveHint) {
              <div>Click to remove from library</div>
            } @else if (showRandomLootAddHint) {
              <div>Click to add to library</div>
            }
            @if (sim.rule?.completeId) {
              <div><span class="keys"><span class="key">Ctrl</span></span>-Click to go to rule</div>
            }
            @if (showItemLibraryRemoveHint || showRandomLootAddHint) {
              <div><span class="keys"><span class="key">Alt</span></span>-Click to clone in Item Designer</div>
            }
            @if (showCopyItemTextHint) {
              <div><span class="keys"><span class="key">Ctrl</span><span class="keys-plus">+</span><span class="key">C</span></span> to copy item text</div>
            }
          </div>
        }
      </div>
    </div>
  }
</ng-template>

<ng-template #explainerFooter>
  @if (uniqueExplainerHtml) {
    <div class="it-section it-description property-color explainer-hint">
      <span class="icon icon-tutor"></span><span [innerHTML]="uniqueExplainerHtml"></span>
    </div>
  }
  @if (recipeExplainerHtml) {
    <div class="it-section it-description property-color explainer-hint">
      <span class="icon icon-tutor"></span><span [innerHTML]="recipeExplainerHtml"></span>
    </div>
  }
</ng-template>
